import { render, staticRenderFns } from "./MidiaKpis.vue?vue&type=template&id=b160e280&scoped=true&"
import script from "./MidiaKpis.vue?vue&type=script&lang=js&"
export * from "./MidiaKpis.vue?vue&type=script&lang=js&"
import style0 from "./MidiaKpis.vue?vue&type=style&index=0&id=b160e280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b160e280",
  null
  
)

export default component.exports